export default __webpack_public_path__ + "static/media/pet-preforms-one.104fb9c6.jpg";